<section class="section reviews-section">
  <div class="container">
    <div class="section-heading">
      <h2>{{'landing.reviews.title'|traduccion}}</h2>
      @if (average !== null && average !== undefined) {
        <p class="review-average"><span aria-hidden="true">★</span> {{'landing.reviews.average'|traduccion:{rating: average} }}</p>
      }
    </div>

    <div id="reviews" class="review-grid" role="region" [attr.aria-label]="'landing.reviews.label'|traduccion" tabindex="0">
      @for (review of reviews; track review.id) {
        <article class="review-card">
          <div class="stars" [attr.aria-label]="'landing.reviews.rating'|traduccion:{rating: review.rating}">{{ stars(review.rating) }}</div>
          <blockquote>“{{ isExpanded(review.id) ? review.text : previewText(review.text) }}”</blockquote>
          @if (review.text.length > previewLength) {
            <button
              class="review-toggle"
              type="button"
              [attr.aria-expanded]="isExpanded(review.id)"
              (click)="toggleReview(review.id)">
              {{ (isExpanded(review.id) ? 'landing.reviews.readLess' : 'landing.reviews.readMore') | traduccion }}
            </button>
          }
          <strong>{{ review.author }}</strong>
        </article>
      }
    </div>
  </div>
</section>
